<template>
    <div :class="['msMenu',isMenuOpen ? 'msOpen' : '']">
        <div @click="$emit('close-menu')" class="closebtn"></div>        
        <ul>          
          <li v-for="(item, index) in sectionsListData" :key="index" @click="navTo(index)">
            <!-- <span v-if="item.menu_title!=null" :style="getStyleIndex(index)">{{localize(item.menu_title)}}</span> -->
            
            <span :style="getStyleIndex(index)" v-if="item.menu_title!=null">
              {{localize(item.menu_title)}}
            </span>
            <span :style="getStyleIndex(index)" v-else>
              {{localize(item.title)}}
            </span>

          </li>          
        </ul>
        <div class="langSelector" v-if="siteLanguages.length>1">
          <i class="fal fa-globe" style="--index:6"></i>          
          <a :style="getStyleIndexAdd(index,7)" v-for="(lang,index) in siteLanguages" 
          :key="lang" :href="getLangLink(lang)" :class="[siteLang == lang ? 'active' : '']">
            {{lang.name}}
          </a>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines } from "@/utils";

export default {
    name: "menu",
    props: {
        isMenuOpen: Boolean
    },
    data()
    {
        return {
            itemx:[]
          }
    },
    methods:
    {
      getLangLink(lang)
      {
        return "/"+lang.lc;
      },
      navTo(index)
      {
        let realIndex = index;
        if(index>0){
          //the first real index is index 1 and not 0  
          //beacuse the first dom section is transparnet (for the fixed video)
          realIndex++;
        }

        this.$emit('close-menu');
        document.getElementsByClassName("siteSection")[realIndex].scrollIntoView({ 
          behavior: 'smooth' 
        });

      },
      getStyleIndexAdd(index,add)
      {
        let stIndex = index+add;
        return "--index:"+stIndex;
      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["siteData","siteDataReady","siteLang"]),
        sectionsListData()
        {
            return this.siteData.SECTIONS;
        },
        siteLanguages()
        {
            return this.siteData.LANGAUGES;
        }

    }
};

</script>


<style>
  .msMenu
  {
      position: fixed;
      top: 0px;
      right: 0px;
      width: 50vw;
      height: 100vh;
      overflow: hidden;
      background-color: #0b6bac;
      /* background-color: #2f6079; */
      /* var(--text-blue)*/
      z-index: 1000;
      display: grid;
      align-items: center;
      text-align: left;
      opacity: 1;
      clip-path: inset(0px 0px 0% 100%);
      transition: all 0.6s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      pointer-events: none;
      padding: 0px 100px;
  }
  .msMenu.msOpen
  {
      pointer-events: all;opacity: 1;clip-path: inset(0px 0px 0px 0px);
  }
  .msMenu .closebtn
  {
    position: absolute;top: 3vh;right:3vh;z-index: 2000;
    opacity: 0.4;
    cursor: pointer;
  }
  .msMenu .closebtn:before,
  .msMenu .closebtn:after
  {
    background-color: #fff !important;
  }
  .msMenu ul
  {
    list-style: none;
    padding:0px;
  }
  .msMenu ul li
  {
    cursor: pointer;
    line-height: 40px;
    letter-spacing: 0px;
    overflow: hidden;
    opacity: 0.8;
  }
  .msMenu ul li span{color:#fff !important;}  
  .msMenu ul li span
  {
    cursor: pointer !important;
    font-size: 24px;
    line-height: 40px;
    font-weight: 300 !important;
    letter-spacing: 0px !important;
    position: relative;
    top: 35px;
    transition-property: top;
    transition-duration: 0.7s;
    transition-delay: calc(0.3s + (0.03s * var(--index))) !important;
    transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .msMenu.msOpen ul li span
  {
    top: 0px;
  }
  .langSelector
  {
    clear: both;
    width: 100%;
    opacity: 0;
    transition: all ease 0.4s;
    transition-delay: 1s;
  }
  .msMenu.msOpen .langSelector
  {
    opacity: 1;
  }

  .langSelector i
  {
    color: #fff;padding-right: 10px;
  }


  .langSelector a:visited,
  .langSelector a
  {
    color:#fff;
    padding-right: 8px;
    font-size: 14px;
    opacity: 0.8;
    cursor: pointer;
  }
  .langSelector a.active
  {
    opacity: 1 !important;
    font-weight: 400;
  }
  


  @media (hover: hover) {
    .msMenu ul li:hover{
      cursor: pointer !important;
      opacity: 1;
    }
    .langSelector a:visited,
    .langSelector a:hover
    {
      color:#fff !important;
      opacity: 1;
    }

  }

  @media (max-width: 850px) { 
  .msMenu
  {
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      padding: 70px 50px 0px 50px;
      display: block;
  }    
  .msMenu.msOpen{
      pointer-events: all;opacity: 1;clip-path: inset(0px 0px 0px 0px);
  }
    .msMenu ul li{
      opacity: 1;
    }
    .msMenu ul li span{
      font-size: 20px;
      line-height: 39px;
      font-weight: 400 !important;
      letter-spacing: -1px !important;
    }    
    .langSelector
    {
      padding-top: 30px;
    }
  }  
</style>